import classnames from 'classnames';
import React, { FC } from 'react';
import { useAudioPlayback } from '../../../../../../utils/hooks/useAudioPlayback';
import { getFileExtension } from '../../../../../../utils/media-manager-sdk/items';
import { IFileThumbnail } from '../../../../../common/Thumbnails/types';
import { MusicControls } from '../../../../Generic/Controls/MusicControls';
import styles from '../ListFileThumbnail.scss';
import { ListFileThumbnailLabel } from '../ListFileThumbnailLabel';
import { ListFileThumbnailNotReadyGuard } from '../ListFileThumbnailNotReadyGuard';

export const Music: FC<IFileThumbnail> = ({ file, className, dataHook, labelClassName, controlsClassName }) => {
  const { isPlaying } = useAudioPlayback(file);

  return (
    <div className={classnames({ [styles.isPlaying]: isPlaying }, className)} data-hook={dataHook}>
      <ListFileThumbnailNotReadyGuard item={file}>
        <>
          <ListFileThumbnailLabel
            className={classnames(styles.label, labelClassName)}
            label={`.${getFileExtension(file)}`}
          />

          <MusicControls
            file={file}
            size="small"
            buttonClassName={classnames(styles.musicPlayButton, controlsClassName)}
          />
        </>
      </ListFileThumbnailNotReadyGuard>
    </div>
  );
};
